import { Component } from '@angular/core';
import {AlertController, IonicPage, NavController, NavParams, ToastController} from 'ionic-angular';
import {UserProvider} from "../../providers/user";
import {TeamappProvider} from "../../providers/teamapp";
import {WebfleetReportPage} from "../webfleet-report/webfleet-report";
import {WebfleetChooseWorkPage} from "../webfleet-choose-work/webfleet-choose-work";
import {WebfleetSignaturePadPage} from "../webfleet-signature-pad/webfleet-signature-pad";
import * as moment from 'moment';
/**
 * Generated class for the WebfleetReportListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-webfleet-report-list',
  templateUrl: 'webfleet-report-list.html',
})
export class WebfleetReportListPage {
  title: string = 'Tagesberichte';
  data: any;
  week: any = 1;
  year: any = new Date().getFullYear();
  lastSelectedCostcenter: any;
  workstate: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, public toastCtrl: ToastController, public userProvider: UserProvider, public teamappProvider: TeamappProvider, public alertCtrl: AlertController) {
    this.week = this.getWeek();
    //this.loadOverview();
    console.log("WEEK OUTPUT");
    console.log(this.getWeek());
  }

  ionViewDidEnter() {
    this.loadAll();
  }

  loadAll() {
    this.loadOverview();
    this.getLastCostcenter();
    this.getState();
  }

  deleteItem(itemid: any) {
    const confirm = this.alertCtrl.create({
      title: 'Löschen',
      message: 'Möchtest du die Position löschen?',
      buttons: [
        {
          text: 'Nein',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Ja',
          handler: () => {
            this.teamappProvider.http_request('action=delete_manual&manual_id='+itemid, 'webfleet', false, true).then(data => {
              this.loadAll();
            });
          }
        }
      ]
    });
    confirm.present();

  }

  loadOverview() {
    this.teamappProvider.http_request('action=get_timeline&week='+this.week, 'webfleet', false).then(data => {
      this.data = data;
      console.log('get timeline data');
      console.log(this.data);
    });
  }

  openTime(day: number) {
    console.log(this.data.days[day-1].status);
    if(this.data.days[day-1].status != '') {
      /* Warning for Sick or Vacation*/
      /*const alert = this.alertCtrl.create({
        title: 'Fehler!',
        subTitle: 'Dieser Tag kann nicht bearbeitet werden! <br><br><b>Grund: '+this.data.days[day-1].status+'</b>',
        buttons: ['OK']
      });
      alert.present();
      */
      this.navCtrl.push(WebfleetReportPage, {data: this.data, day: day});
    } else {
      this.navCtrl.push(WebfleetReportPage, {data: this.data, day: day});
    }
  }

  getWorkState() {

  }

  getState() {
    this.teamappProvider.http_request('action=get_working_state', 'webfleet', false, false).then(data => {
      let tmpWS: any = data;
      this.workstate = tmpWS;
      console.log("getting_working_state");
      console.log(this.workstate);
    });
  }

  addComment() {
    console.log(this.lastSelectedCostcenter);
    const prompt = this.alertCtrl.create({
      title: 'Kommentar abgeben',
      message: "Gebe einen Kommentar zur aktuellen Kostenstelle <b>"+this.lastSelectedCostcenter.objectname+"</b> ab. <br><br>Dein Kommentar kann jederzeit in dieser Maske geändert werden!",
      inputs: [
        {
          name: 'comment',
          placeholder: 'Kommentar',
          value: this.lastSelectedCostcenter.comment,
        },
      ],
      buttons: [
        {
          text: 'Abbrechen',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Speichern',
          handler: data => {
            if(data.comment) {
              this.teamappProvider.http_request('action=add_costcenter_comment&manual_comment='+data.comment, 'webfleet', false, true).then(data => {
                this.loadAll();
              });
            }

          }
        }
      ]
    });
    prompt.present();
  }
  changeCostcenter() {
    this.navCtrl.push(WebfleetChooseWorkPage, {isChange: true});
  }

  getLastCostcenter() {
    this.teamappProvider.http_request('action=get_last_costcenter', 'webfleet', false, false).then(data => {
      let tmpLC: any = data;
      this.lastSelectedCostcenter = tmpLC;
      console.log("getting_last_costcenter");
      console.log(this.lastSelectedCostcenter);
    });
  }

  changeWeekIfRequired() {
    if(this.week != this.getWeek()) {
        this.week = this.getWeek();
        const toast = this.toastCtrl.create({
          message: 'Zur aktuellen Kalenderwoche gewechselt',
          duration: 6000
        });
        toast.present();
    }
  }

  clickBreak() {
    this.addPositionMask('Pause', false, true, 'manual_break');
  }

  bookPosition() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Position Einbuchen');

    alert.addInput({
      type: 'radio',
      label: 'Tanken',
      value: 'fuel',
    });

    alert.addInput({
      type: 'radio',
      label: 'Wartezeit',
      value: 'waiting',
    });

    alert.addInput({
      type: 'radio',
      label: 'ADR Zuschlag',
      value: 'adr',
    });

    alert.addInput({
      type: 'radio',
      label: 'Werkstatt',
      value: 'maintance',
    });

    alert.addInput({
      type: 'radio',
      label: 'Waschen / Spülen',
      value: 'washing',
    });

    alert.addInput({
      type: 'radio',
      label: 'Einarbeitung',
      value: 'help',
    });

    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        /*if(data == 'break') {
          this.addPositionMask('Pause', false, true, 'manual_break');
        }*/
        if(data == 'fuel') {
          this.addPositionMask('Tanken', true, true, 'manual_fuel');
        }
        if(data == 'waiting') {
          this.addPositionMask('Wartezeit', true, true, 'manual_waiting');
        }
        if(data == 'maintance') {
          //
          this.navCtrl.push(WebfleetSignaturePadPage);
        }
        if(data == 'washing') {
          this.addPositionMask('Waschen', true,true, 'manual_washing');
        }
        if(data == 'adr') {
          this.addPositionMask('ADR', false,true, 'manual_adr');
        }
        /*if(data == 'problem') {
          this.addPositionMask('Problem', false,false, 'manual_problem');
        }*/

        /*if(data == 'others') {
          this.othersAdd();
        }*/
        if(data == 'help') {
          this.addPositionMask('Einarbeitung', true,true, 'manual_help');
        }
      }
    });
    alert.present();
  }

  addPositionMask(title: string, comment: boolean = true, time: boolean = true, db_type: string) {
    let alert = this.alertCtrl.create();
    alert.setTitle(title);

    let date: any = moment().format('YYYY-MM-DD');
    console.log(date);

    if(comment == true) {
      alert.addInput({
        type: 'text',
        label: 'Kommentar *',
        name: 'comment',
        placeholder: 'Kommentar *',
        value: '',
      });
    }

    alert.addInput({
      name: 'date_from',
      type: 'date',
      label: 'Datum Von *',
      value: date,
    });

    if(time == true) {

      alert.addInput({
        name: 'time_from',
        type: 'time',
        label: 'Zeit Von *',
        value: date,
      });
    }

    alert.addInput({
      name: 'date_till',
      type: 'date',
      label: 'Datum Bis *',
      value: date,
    });

    if(time == true) {
      alert.addInput({
        name: 'time_till',
        type: 'time',
        label: 'Bis *',
        value: '',
      });

    }

    if(comment == false && time == false) {
      alert.setMessage('Möchtest Du die Position einbuchen?');
    }
    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        if(comment == true && time == true) {
          if((data.time_till > data.time_from) && (data.date_till >= data.date_from)) {
            if(data.comment) {
              console.log(data);
              this.teamappProvider.http_request('action=book_positions&manual_type='+db_type+'&manual_start='+data.date_from+' '+data.time_from+':00&manual_end='+data.date_till+' '+data.time_till+':00&manual_comment='+data.comment, 'webfleet', false, true).then(data => {
                let ret: any = data;
                if(ret.success == false) {
                  this.customAlert(ret.msg);
                } else {
                  this.changeWeekIfRequired();
                  this.loadAll();
                }
              });
            } else {
              this.commentAlert();
            }
          } else {
            this.timeAlert();
          }

        } else if(comment == true) {
          if((data.date_till >= data.date_from)) {
            if(data.comment) {
              this.teamappProvider.http_request('action=book_positions&manual_type=' + db_type + '&manual_comment=' + data.comment, 'webfleet', false, true).then(data => {
                let ret: any = data;
                if(ret.success == false) {
                  this.customAlert(ret.msg);
                } else {
                  this.changeWeekIfRequired();
                  this.loadAll();
                }
              });
            } else {
              this.commentAlert();
            }
          } else {
            this.timeAlert();
          }

        } else if(time == true) {
          if(data.time_till > data.time_from && (data.date_till >= data.date_from)) {
            this.teamappProvider.http_request('action=book_positions&manual_type='+db_type+'&manual_start='+data.date_from+' '+data.time_from+':00&manual_end='+data.date_till+' '+data.time_till+':00', 'webfleet', false, true).then(data => {
              let ret: any = data;
              if(ret.success == false) {
                this.customAlert(ret.msg);
              } else {
                this.changeWeekIfRequired();
                this.loadAll();
              }
            });
          } else {
            this.timeAlert();
          }

        } else {
          if((data.date_till >= data.date_from)) {
            this.teamappProvider.http_request('action=book_positions&manual_type='+db_type , 'webfleet', false, true).then(data => {
              let ret: any = data;
              if(ret.success == false) {
                this.customAlert(ret.msg);
              } else {
                this.changeWeekIfRequired();
                this.loadAll();
              }
            });
          } else {
            this.timeAlert();
          }
        }
        console.log(data);
      }
    });
    alert.present();

  }

  customAlert(msg: string) {
    const alert = this.alertCtrl.create({
      title: 'Fehler!',
      subTitle: msg,
      buttons: ['OK']
    });
    alert.present();
  }

  commentAlert() {
    const alert = this.alertCtrl.create({
      title: 'Fehler!',
      subTitle: 'Es wurde kein Kommentar abgegeben!',
      buttons: ['OK']
    });
    alert.present();
  }

  timeAlert() {
    const alert = this.alertCtrl.create({
      title: 'Fehler!',
      subTitle: 'Die Startzeit muss vor der Endzeit liegen!',
      buttons: ['OK']
    });
    alert.present();
  }

  timeNow() {
    return new Date().toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
  }

  startPause() {
    this.teamappProvider.http_request('action=start_pause', 'webfleet', false, true).then(data => {
      this.changeWeekIfRequired();
      this.loadAll();
      this.userProvider.setUserStatus('<div class="workstate break">Pause</div> seit '+this.timeNow());
    });
  }

  endPause() {
    this.teamappProvider.http_request('action=end_pause', 'webfleet', false, true).then(data => {
      this.changeWeekIfRequired();
      this.loadAll();
      this.userProvider.setUserStatus('<div class="workstate working">Arbeitet</div> seit '+this.timeNow());
    });
  }
  endWork() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Ende auswählen');

    alert.addInput({
      type: 'radio',
      label: 'Standort / Zuhause',
      value: 'Standort / Zuhause',
    });
    alert.addInput({
      type: 'radio',
      label: 'Unterwegs',
      value: 'Unterwegs',
    });
    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'Weiter',
      handler: data => {
        let endLocation = data;
        this.teamappProvider.http_request('action=end_work&manual_comment='+endLocation, 'webfleet', false, true).then(data => {
          this.changeWeekIfRequired();
          this.loadAll();

          this.userProvider.setUserStatus('<div class="workstate not-working">Nicht am Arbeiten</div>');
        });
      }
    });
    alert.present();
  }
  beginWork() {
    let lastWork = this.lastSelectedCostcenter.objectname;
    if(lastWork != '') {
      let lastWorkID = this.lastSelectedCostcenter.objectno;
      const confirm = this.alertCtrl.create({
        title: 'Schicht starten',
        message: 'Deine letzte Kostenstelle ist: '+lastWork+'. <br>Möchtest du diese wieder auswählen?',
        buttons: [
          {
            text: 'Ja',
            handler: () => {
              console.log('Disagree clicked');
              this.teamappProvider.http_request('action=start_work&costcenter='+lastWorkID, 'webfleet', false, true).then(data => {
                this.changeWeekIfRequired();
                this.loadAll();
                this.userProvider.setUserStatus('<div class="workstate working">Arbeitet</div> seit '+this.timeNow());
              });
            }

          },
          {
            text: 'Nein',
            handler: () => {
              this.navCtrl.push(WebfleetChooseWorkPage);
            }
          }
        ]
      });
      confirm.present();
    } else {
      this.navCtrl.push(WebfleetChooseWorkPage);
    }
  }

  openWeekOverview() {
    let alert = this.alertCtrl.create();
    alert.setTitle('Kalenderwochen');

    let Y = new Date().getFullYear();
    Y = Y-1;
    alert.addInput({
      type: 'radio',
      label: '51. Kalenderwoche('+Y+')',
      value: '-2',
      checked: false
    });
    alert.addInput({
      type: 'radio',
      label: '52. Kalenderwoche('+Y+')',
      value: '-1',
      checked: false
    });

    for(let i = this.getWeek()+1;i>=1;i--) {
      let checked = false;
      if(i == this.week) {
        checked = true;
      }
      alert.addInput({
        type: 'radio',
        label: i+'. Kalenderwoche',
        value: ''+i+'',
        checked: checked
      });
    }


    alert.addButton('Abbrechen');
    alert.addButton({
      text: 'OK',
      handler: data => {
        this.week = data;
        this.loadOverview();
      }
    });
    alert.present();
  }

  getWeek() {
    var date = new Date();
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    var week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
        - 3 + (week1.getDay() + 6) % 7) / 7);
  }

  refreshOverview(event: any) {
    this.loadOverview();
    event.complete();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WebfleetReportOverviewPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/webfleet-report-list/webfleet-report-list.ts